import { LunaTabName } from "@/types";

import { LunaTabs } from "../features";

import TabContent from "./Tabs";

interface Props {
  activeTab: LunaTabName;
  setActiveTab: (tab: LunaTabName) => void;
  isVisible: boolean;
}

const Luna = ({ activeTab, setActiveTab, isVisible }: Props) => {
  return (
    <div className={`flex flex-col h-full px-4 ${!isVisible ? "hidden" : "flex"
      } overflow-hidden`}>
      <div>
        <LunaTabs activeTab={activeTab} setActiveTab={setActiveTab} isTutor />
      </div>
      <div className="flex-1 min-h-0">
        <TabContent activeTab={activeTab} />
      </div>
    </div >
  );
};

export default Luna;
